<div *ngFor="let field of slice.fields">
    @switch (field?.section_type) {
        @case ('price') {
            <app-plan-select [plans]="plans" [_deductible]="deductible"
                (chosenPlan)="switchPlan($event)" (emitAddToCart)="addToCart($event)" (changeTerms)="getTerms($event)" [ratesBackground]="slice?.primary?.product?.new_rates_card_brand_color">
            </app-plan-select>
        }
        @case ('parts_checklist') {
            @if (thisBrand !== 'HPP' && thisBrand !== 'Hyundai' && thisBrand !== 'Genesis') {
                <app-coverage-select [plans]="plans" [chosenPlan]="chosenPlan"
                    [_commercial_use_toggle]="commercial_use_toggle" [_snow_plow_toggle]="snow_plow_toggle"
                    [_lift_kit_toggle]="lift_kit_toggle" [_grey_market_toggle]="grey_market_toggle"
                    [changeTerms]="changeTerms" [_deductible]="deductible" [index]="closestTerm"
                    (chosenTerm)="changeTerm($event)" (emitChangeTerms)="getTerms($event)"
                    (emitAddToCart)="addToCart($event)" (emitUpdatePricing)="updatePricing($event)">
                </app-coverage-select>
            }
        }
        @case ('sample_pdf') {
            <app-plan-pdf></app-plan-pdf>
        }
        @case ('term_length') {
            <app-covered-components [plan]="chosenPlan"></app-covered-components>
        }
        @case ('plans_includes') {
            <app-coverage-overview [plan]="chosenPlan"></app-coverage-overview>
        }
        @case ('plans_overview') {
            <app-plans-overview [plan]="chosenPlan"></app-plans-overview>
        }
        @case ('price') {
            @if (thisBrand !== 'HPP' && thisBrand !== 'Hyundai' && thisBrand !== 'Genesis') {
                <app-mobile-plan-footer [plan]="chosenPlan"
                    (emitAddToCart)="addToCart($event)"></app-mobile-plan-footer>
            }
        }
    }
</div>